module.exports = __webpack_public_path__ + "static/media/drumnow-7.66e152a3.jpg";